export function getPaymentMethodsDropdown () {
  return [
    {
      label: 'Velg betalingsmetode',
      key: null,
      disabled: true
    },
    {
      label: 'Fakturer og skriv ut / send manuelt',
      key: 'none'
    },
    {
      label: 'Sende faktura',
      key: 'faktura'
    }
  ]
}

export function getcreditTypeDropdown () {
  return [
    {
      label: 'Velg type av kreditering',
      key: null,
      disabled: true
    },
    {
      label: 'Kreditere for å fakturere kunden på nytt',
      key: 'invoice'
    },
    {
      label: 'Kreditere for å selge på nytt',
      key: 'sell'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/helpers/Constants.js